import { useContentTypeReportes } from '../../../../../../pages/Reportes/useReportes.hook'
import FavoriteNavBar from './FavoriteNavBar'
//import ListLibroDiario from '../../../../../../pages/Reportes/libroDiario/ListLibroDiario'
import { Button} from '@mui/material'
import ListPorPagar from '../../../../../../pages/Reportes/porPagar/ListPorPagar'
import ListEstadoDeResultadosExtend from '../../../../../../pages/Reportes/estadoDeResultadoExtendido/ListEstadoDeResultadosExtend'
import ListEstadoDeResultados from '../../../../../../pages/Reportes/estadoDeResultado/ListEstadoDeResultados'
import ListPorCobrar from '../../../../../../pages/Reportes/porCobrar/ListPorCobrar'
import ListBalanceGeneral from '../../../../../../pages/Reportes/balanceGeneral/ListBalanceGeneral'
import ListLibroAuxiliarCliente from '../../../../../../pages/Reportes/libroAuxiliarCliente/ListLibroAuxiliarCliente'
import ListLibroAuxiliarProveedores from '../../../../../../pages/Reportes/libroAuxiliarProveedores/ListLibroAuxiliarProveedores'
import ListConciliacion from '../../../../../../pages/Reportes/conciliaciones/ListConciliaciones'
import ListLibroDiario from '../../../../../../pages/Reportes/libroDiario/ListLibroDiario'
import ListLibroMayor from '../../../../../../pages/Reportes/libroMayor/ListLibroMayor'
import ListLibroBancoConciliaciones from '../../../../../../pages/Reportes/libroBancoConciliaciones/ListLibroBancoConciliaciones'
import { useState } from 'react'
import ResizableModal from '../../../../ui/ResizableModal'

const Index = () => {
  const favoriteContent = useContentTypeReportes(state => state.favoriteContent)
  const favoriteIcons = useContentTypeReportes(state => state.favoriteIcons)
  const [showModal, setShowModal] = useState(false)

  const renderFavoriteContent = () => {
    switch (favoriteContent) {
      case '2':
        return <ListEstadoDeResultados/>
      case '3':
        return <ListEstadoDeResultadosExtend />
      case '4':
        return <ListPorCobrar />
      case '5':
        return <ListBalanceGeneral />
      case '6':
        return <ListPorPagar />
      case '8':
        return <ListLibroAuxiliarCliente />
      case '9':
        return <ListLibroAuxiliarProveedores />
      case '10':
        return <ListConciliacion/>
      case '11':
        return <ListLibroDiario />
      case '12':
        return <ListLibroMayor />
      case '13':
        return <ListLibroBancoConciliaciones />
      default:
        return <div></div>
    }
  }

  return (
    <div>
      <FavoriteNavBar setShowModal={setShowModal}/>
        <ResizableModal open={showModal} onClose={e => {
            e.stopPropagation()
            setShowModal(false)
          }}
        footer={
          <>
            <Button
              variant='contained'
              sx={{
                borderRadius: '50px',
                backgroundColor: '#000033',
                color: '#FFFFFF',
                '&:hover': { backgroundColor: '#000033' }
              }}
              onClick={() => setShowModal(false)}
            >
              Cerrar
            </Button>
          </>
        }
        >
          <div className='p-6'>
            {favoriteIcons.length > 0 && favoriteContent && renderFavoriteContent()}
          </div>
        </ResizableModal>
    </div>
  )
}

export default Index
